import type {ReactNode} from 'react';

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible';
import {Typography} from '@/components/ui/typography';

import {useAutoCollapse} from '../hooks/useAutoCollapse';
import EvacuationCountBadge from './EvacuationCountBadge';

type EvacuationSectionProps = {
  title: string;
  confirmedCount: number;
  totalCount: number;
  forceOpen?: boolean;
  children: ReactNode;
};

const EvacuationSection = ({
  title,
  confirmedCount,
  totalCount,
  forceOpen,
  children,
}: EvacuationSectionProps) => {
  const {isOpen, onOpenChange} = useAutoCollapse(
    confirmedCount,
    totalCount,
    forceOpen
  );

  return (
    <Collapsible
      variant="section"
      open={isOpen}
      onOpenChange={onOpenChange}
      asChild
    >
      <section>
        <CollapsibleTrigger variant="section">
          <Typography variant="h3" asChild>
            <span className="grow">{title}</span>
          </Typography>
          <EvacuationCountBadge
            confirmedCount={confirmedCount}
            totalCount={totalCount}
          />
        </CollapsibleTrigger>
        <CollapsibleContent variant="section">{children}</CollapsibleContent>
      </section>
    </Collapsible>
  );
};

export default EvacuationSection;
